import { v4 } from 'uuid';

const getCookie = (name: string) => {
  const cookie = {};
  document.cookie.split(';').forEach((el) => {
    const [key, value] = el.split('=');
    // @ts-ignore
    cookie[key.trim()] = value;
  });
  // @ts-ignore
  return cookie[name];
};

export const getAnonymousUserid = () => {
  // This is named to match the default key set by segment
  const cookieName = 'ajs_anonymous_id';

  const anonymousId = getCookie(cookieName);
  if (anonymousId === undefined) {
    const localStorageAnonymousId = localStorage.getItem(cookieName);
    if (localStorageAnonymousId === null) {
      const uuid = v4();
      localStorage.setItem(cookieName, uuid);
      document.cookie = `${cookieName}=${uuid}; path=/`;
    } else {
      document.cookie = `${cookieName}=${localStorageAnonymousId}; path=/`;
    }
  }

  return getCookie(cookieName);
};
